package com.sweetlime.bingeamigo.presentation.features.tvdetail

import androidx.compose.runtime.Composable
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.sweetlime.bingeamigo.model.SeasonSummary
import com.sweetlime.bingeamigo.model.TvShow

data class SeasonDetailScreen(
    // TvShow primitives
    val tvShowId: Int,
    val tvShowName: String,
    val tvShowOverview: String = "",
    val tvShowAdult: Boolean = false,
    val tvShowBackdropPath: String? = null,
    val tvShowPosterPath: String? = null,
    val tvShowOriginalLanguage: String = "",
    val tvShowOriginalName: String = "",
    val tvShowPopularity: Double = 0.0,
    val tvShowFirstAirDate: String = "",
    val tvShowVoteAverage: Double = 0.0,
    val tvShowVoteCount: Int = 0,
    // SeasonSummary primitives
    val seasonId: Int,
    val seasonName: String,
    val seasonOverview: String = "",
    val seasonAirDate: String = "",
    val seasonEpisodeCount: Int = 0,
    val seasonPosterPath: String? = null,
    val seasonNumber: Int = 0,
    val seasonVoteAverage: Double = 0.0,
    // Other
    val showPosterFallback: String,
    val totalEpisodesInShow: Int
) : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val tvShow = TvShow(
            id = tvShowId,
            name = tvShowName,
            overview = tvShowOverview,
            adult = tvShowAdult,
            backdropPath = tvShowBackdropPath,
            posterPath = tvShowPosterPath,
            originalLanguage = tvShowOriginalLanguage,
            originalName = tvShowOriginalName,
            popularity = tvShowPopularity,
            firstAirDate = tvShowFirstAirDate,
            voteAverage = tvShowVoteAverage,
            voteCount = tvShowVoteCount
        )
        val season = SeasonSummary(
            id = seasonId,
            name = seasonName,
            overview = seasonOverview,
            airDate = seasonAirDate,
            episodeCount = seasonEpisodeCount,
            posterPath = seasonPosterPath,
            seasonNumber = seasonNumber,
            voteAverage = seasonVoteAverage
        )
        SeasonDetailContent(
            tvShow = tvShow,
            season = season,
            showPosterFallback = showPosterFallback,
            totalEpisodesInShow = totalEpisodesInShow,
            onBackClick = { navigator.pop() },
            onEpisodeClick = { episode ->
                navigator.push(EpisodeDetailScreen(tvShow, episode, totalEpisodesInShow))
            }
        )
    }
}

fun SeasonDetailScreen(
    tvShow: TvShow,
    season: SeasonSummary,
    showPosterFallback: String,
    totalEpisodesInShow: Int
) = SeasonDetailScreen(
    tvShowId = tvShow.id,
    tvShowName = tvShow.name,
    tvShowOverview = tvShow.overview,
    tvShowAdult = tvShow.adult,
    tvShowBackdropPath = tvShow.backdropPath,
    tvShowPosterPath = tvShow.posterPath,
    tvShowOriginalLanguage = tvShow.originalLanguage,
    tvShowOriginalName = tvShow.originalName,
    tvShowPopularity = tvShow.popularity,
    tvShowFirstAirDate = tvShow.firstAirDate,
    tvShowVoteAverage = tvShow.voteAverage,
    tvShowVoteCount = tvShow.voteCount,
    seasonId = season.id,
    seasonName = season.name,
    seasonOverview = season.overview,
    seasonAirDate = season.airDate,
    seasonEpisodeCount = season.episodeCount,
    seasonPosterPath = season.posterPath,
    seasonNumber = season.seasonNumber,
    seasonVoteAverage = season.voteAverage,
    showPosterFallback = showPosterFallback,
    totalEpisodesInShow = totalEpisodesInShow
)